import * as React from "react";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  resolveString,
  useCurrentCase,
  useDispatch,
  useParams,
  EMAIL_REGEX
} from "duck";
import { useUpdateClientInformationMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateClient = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { clientId, shouldSync } = useCurrentCase(medicalCase => ({
    clientId: medicalCase.data.client._id,
    shouldSync: medicalCase.shouldSync
  }));
  const [update] = useUpdateClientInformationMutation({ ignoreResults: true });

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      const variables = omitBy(
        {
          accountNumber: resolveString(values.accountNumber),
          email:
            values.email === ""
              ? null
              : typeof values.email === "string" &&
                !!values.email.match(EMAIL_REGEX)
              ? values.email
              : undefined,
          firstName: resolveString(values.firstName),
          lastName: resolveString(values.lastName),
          streetAddress: resolveString(values.streetAddress),
          apartments: values.apartments,
          state: values.state,
          city: values.city,
          zipCode: values.zipCode,
          phoneFirst: resolveString(values.phoneFirst),
          phoneSecond: resolveString(values.phoneSecond),
          notAvailableTime: resolveString(values.notAvailableTime)
        },
        value => value === undefined
      );
      dispatch(casesActions.updateClientInfo({ _id: id, data: variables }));

      if (shouldSync) {
        return update({
          variables: { input: { _id: clientId, ...variables } }
        });
      }
    },
    [clientId, shouldSync, update]
  );
};
